import { AdditionalServicesOffering } from '@shared/models/additional-services-offering.model';
import { VoiceSubscriptionOffering } from '../../modules/subscription/models/offerings-response.model';

export class ApiGetOfferingsAction {
  static readonly type = '[Api] Get Voice Offerings';
}

export class ApiGetOfferingsSuccessAction {
  static readonly type = '[Api] Get Voice Offerings Success';
  constructor(public offeringResponse: VoiceSubscriptionOffering[]) {}
}

export class ApiGetOfferingsErrorAction {
  static readonly type = '[Api] Get Voice Offerings Error';
}

export class SetAvailableForChangeOfferingsAction {
  static readonly type = '[Api] Set Available For Change Offerings';
  constructor(public offeringResponse: VoiceSubscriptionOffering[]) {}
}

export class ApiGetAdditionalServiceOfferingsAction {
  static readonly type = '[Api] Get AdditionalServices for Voice Offering';
  constructor(
    public offeringId: string,
    public productId: string
  ) {}
}

export class ApiGetAdditionalServiceOfferingsSuccessAction {
  static readonly type = '[Api] Get AdditionalService Voice Offerings Success';
  constructor(public additionalServices: AdditionalServicesOffering) {}
}

export class ApiGetAdditionalServiceOfferingsErrorAction {
  static readonly type = '[Api] Get AdditionalServicesOfferings Error';
  constructor(public error: string) {}
}

export class OfferingResetAction {
  static readonly type = '[Offering] Reset offering state';
}
